module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Active",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOpenOffers($event)
      }
    },
    model: {
      value: (_vm.filters.openOfferFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "openOfferFilter", $$v)
      },
      expression: "filters.openOfferFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOpenOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseActiveOffer', 'activeOffer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.openOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createBy",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bouns"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.leftNum > 0) ? _c('p', [_c('el-tag', [_vm._v("Can Take")])], 1) : _vm._e(), _vm._v(" "), (scope.row.leftNum <= 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("No surplus")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showTakeOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Take")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.openOfferTotal
    },
    on: {
      "current-change": _vm.changeOfferPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Proposed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProposedOffers($event)
      }
    },
    model: {
      value: (_vm.filters.proposedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "proposedFilter", $$v)
      },
      expression: "filters.proposedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProposedOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showProposed
    }
  }, [_vm._v("Request")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseProposedOffer', 'proposedOffer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.proposedOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("cancelled")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelProposed(scope.row.id, 2)
            }
          }
        }, [_vm._v("Cancel")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.proposedTotal
    },
    on: {
      "current-change": _vm.changeProposedPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Expired",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getExpiredOffers($event)
      }
    },
    model: {
      value: (_vm.filters.expiredFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "expiredFilter", $$v)
      },
      expression: "filters.expiredFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getExpiredOffers
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.expiredList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createBy",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bouns"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showProposedOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Propose")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.expiredTotal
    },
    on: {
      "current-change": _vm.changeExpiredPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Offer History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOfferHistroy($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOfferHistroy
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": _vm.getOfferHistroy
    },
    model: {
      value: (_vm.filters.historyStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyStatus", $$v)
      },
      expression: "filters.historyStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Completed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseOfferHistory', 'offerHistory.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.historyList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctor",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offerCreateTime",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Take Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Completed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Take Offer",
      "width": "80%",
      "visible": _vm.takeOfferVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.takeOfferVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "takeOffer",
    attrs: {
      "model": _vm.takeOffer,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "company",
      "prop": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.createBy),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "createBy", $$v)
      },
      expression: "takeOffer.createBy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.product),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "product", $$v)
      },
      expression: "takeOffer.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.takeOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "price", $$v)
      },
      expression: "takeOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": true
    },
    model: {
      value: (_vm.takeOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "bouns", $$v)
      },
      expression: "takeOffer.bouns"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.takeOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "leftNum", _vm._n($$v))
      },
      expression: "takeOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.takeOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "quantity", _vm._n($$v))
      },
      expression: "takeOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.takeOffer.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.takeOffer, "warehouseNo", $$v)
      },
      expression: "takeOffer.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.takeOfferVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleTakeOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Proposed offer",
      "width": "80%",
      "visible": _vm.proposedOfferVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.proposedOfferVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "proposedOffer",
    attrs: {
      "model": _vm.proposedOffer,
      "label-width": "220px",
      "rules": _vm.proposedFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "offerNo"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "clearable": "",
      "disabled": ""
    },
    on: {
      "change": _vm.selectProposedOffer
    },
    model: {
      value: (_vm.proposedOffer.offerNo),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "offerNo", $$v)
      },
      expression: "proposedOffer.offerNo"
    }
  }, _vm._l((_vm.proposedList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.productName + ' (' + item.createDate + ')',
        "value": item.offerNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.proposedOffer.offerNo) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "company",
      "prop": "createBy"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.proposedOffer.createBy),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "createBy", $$v)
      },
      expression: "proposedOffer.createBy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.proposedOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "price", $$v)
      },
      expression: "proposedOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.proposedOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "quantity", $$v)
      },
      expression: "proposedOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.proposedOffer.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.proposedOffer, "warehouseNo", $$v)
      },
      expression: "proposedOffer.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.proposedOfferVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestProposed($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52bf84c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nurse/offer.vue
// module id = 782
// module chunks = 1